import { Checkbox } from "@mui/material";
import  { useEffect, useState } from "react";

const CustomInputs = (props: any) => {
  const {
    type,
    label,
    name,
    placeholder,
    value,
    onChange,
    submit,
    labelIsBold,
    option,
    labelKey,
    valueKey,
    validation,
    disable_dates,
    labelNote,
    condition,
    isPending,
    message,
    labelTop,
    width,disabled,
    checkBoxLabel
  } = props;
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  let todayDate = () => {
    let today = new Date();
    let date =
      condition ||
      `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(today.getDate()).padStart(2, "0")}`;
    return date;
  };
  const renderInput = () => {
    switch (type) {
      case "normal":
        return (
          <input
            type="text"
            className={`form-control ${submit && error ? "is-invalid" : ""}`}
            id={name}
            name={name}
            value={props[name] || value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            style={{ borderRadius: "10px" }}
            onInput={props.onInput}
            width={width}
            autoComplete="new-password"
          />
        );
      case "text":
        return (
          <input
            type="text"
            className={`form-control ${submit && error ? "is-invalid" : ""}`}
            id={name}
            name={name}
            value={props[name] || value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={isPending || disabled}
            width={width}
            onInput={props.onInput}
            autoComplete="new-password"
          />
        );
      case "textarea":
        return (
          <textarea
            className={`form-control ${submit && error ? "is-invalid" : ""}`}
            id={name}
            name={name}
            value={props[name] || value}
            onChange={onChange}
            disabled={isPending}
            placeholder={placeholder}
            style={{ borderRadius: "10px" }}
            onInput={props.onInput}
            autoComplete="new-password"
          />
        );
      case "select":
        return (
          <select
            className={`form-select ${submit && error ? "is-invalid" : ""}`}
            id={name}
            name={name}
            value={props[name] || value}
            onChange={onChange}
            disabled={isPending}
            style={{ borderRadius: "10px" }}
          >
            <option value="">Select</option>
            {option?.map((item, index) => (
              <option key={index} value={item[valueKey]}>
                {item[labelKey]}
              </option>
            ))}
          </select>
        );
      case "checkbox":
        return (
          <Checkbox
            id={name}
            name={name}
            checked={props[name] || value}
            onChange={onChange}
            color="secondary"
            disabled={isPending}
          />
        );
      default:
        return (
          <input
            type={type}
            className={`form-control ${submit && error ? "is-invalid" : ""}`}
            id={name}
            name={name}
            value={props[name] || value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={isPending}
            min={disable_dates === "min" ? todayDate() : null}
            style={{ borderRadius: "10px" }}
            onInput={props.onInput}
            autoComplete="new-password"
          />
        );
    }
  };
  
  useEffect(() => {
    if (submit) {
      console.log(validation)
      if (validation === "required") {
        setError(!props[name]);
        setErrorMsg(label ? `${label} is required!` : "");
      }
    }
  }, [submit, props[name], label]);

  return (
    <div>
      
       {(labelTop === "" || labelTop) && (
          <label
            htmlFor={name}
            className={`form-label mb-2 mt-2 f-16 ${
              labelIsBold ? "fw-bold" : "fw-500"
            }`}
          >
            {labelTop}
          </label>
        )}
      <div className="d-flex gap-1 align-items-center">
        {label && (
          <label
            htmlFor={name}
            className={`form-label mb-2 mt-2  f-14 fw-500 fw-bold ${
              labelIsBold ? "fw-bold" : "fw-500"
            }`}
          >
            {label}
            {labelNote && (
              <span className="text-secondary fw-500 f-14">{labelNote}</span>
            )}
          </label>
        )}
        {validation && label && <span className="text-danger ms-1">*</span>}
      </div>
      <div className="input-group mb-2">
        {renderInput()}<span className="d-flex align-items-center">{checkBoxLabel}</span>
        {message && <div>{message}</div>}
      </div>
      {submit && error && (
        <div className="invalid-feedback d-block">{errorMsg}</div>
      )}
    </div>
  );
};

export default CustomInputs;
